import React from 'react';

import LanguageSelect from '../../../../components/Inputs/LanguageSelect';
import {MaxWidthContainer} from '../../../../components/Layout';
import Link from '../../../../components/Link/Link';
import appConfig from '../../../../config/appConfig';
import * as localizationKeys from '../../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../../services/localization/localizationService';
import tncService from '../../../../services/tncService';
import dateTimeUtils from '../../../../utils/dateTimeUtils';

const Footer = () => {
    const localizedStrings = getLocalizedStrings();
    const iqosHomeUrl = appConfig.getIqosHomeUrlFormatted();
    const companyInfoUrl = appConfig.getFooterCompanyInfoUrlFormatted();
    const userLicenseUrl = appConfig.getFooterUserLicenseUrlFormatted();
    const privacyNoticeUrl = appConfig.getFooterPrivacyNoticeUrlFormatted();
    const onTncClick = () => {
        tncService.openLegalSettings();
    };

    return (
        <footer className='bg-primary'>
            <div className='flex justify-center py-7 lg:px-9 lg:py-8'>
                <MaxWidthContainer size='xl' className='w-full font-normal'>
                    <div className='mb-[26px] flex w-full items-center justify-between px-8 text-16 md:px-9 lg:px-0'>
                        {iqosHomeUrl ? (
                            <Link
                                to={iqosHomeUrl}
                                className='leading-15 tracking-05 text-romance no-underline'
                                isExternalLink
                                isTargetBlank
                            >
                                {localizedStrings[localizationKeys.FOOTER_BACK_TO_IQOS]}
                            </Link>
                        ) : (
                            <div />
                        )}
                        <LanguageSelect />
                    </div>
                    <div className='flex w-full flex-col items-center justify-between text-12 lg:flex-row'>
                        <div className='flex w-full flex-col gap-5 border-b border-scarpa-flow px-8 pb-7 md:px-9 lg:m-0 lg:w-max lg:flex-row lg:items-center lg:gap-5 lg:border-0 lg:p-0 xl:gap-10'>
                            {privacyNoticeUrl && (
                                <FooterLink to={privacyNoticeUrl} isExternalLink isTargetBlank>
                                    {localizedStrings[localizationKeys.FOOTER_PRIVACY_NOTICE]}
                                </FooterLink>
                            )}
                            <FooterLink onClick={onTncClick}>
                                {localizedStrings[localizationKeys.FOOTER_TERMS_AND_CONDITIONS]}
                            </FooterLink>
                            {companyInfoUrl && (
                                <FooterLink to={companyInfoUrl} isExternalLink isTargetBlank>
                                    {localizedStrings[localizationKeys.FOOTER_COMPANY_INFORMATION]}
                                </FooterLink>
                            )}
                            {userLicenseUrl && (
                                <FooterLink to={userLicenseUrl} isExternalLink isTargetBlank>
                                    {localizedStrings[localizationKeys.FOOTER_USER_LICENSE]}
                                </FooterLink>
                            )}
                        </div>
                        <div className='w-min pt-7 leading-13 tracking-02 text-romance md:w-max lg:pt-0'>
                            <span className='inline-block w-max'>
                                {localizedStrings.formatString(
                                    localizedStrings[localizationKeys.FOOTER_COPYRIGHT_PART_1],
                                    dateTimeUtils.getCurrentYear()
                                )}
                            </span>{' '}
                            <span className='inline-block w-max'>
                                {localizedStrings[localizationKeys.FOOTER_COPYRIGHT_PART_2]}
                            </span>
                        </div>
                    </div>
                </MaxWidthContainer>
            </div>
        </footer>
    );
};

export default Footer;

const FooterLink = (props) => <Link className='w-max leading-13 tracking-02 text-romance no-underline' {...props} />;
